import(/* webpackMode: "eager" */ "/vercel/path0/apps/example-apps/react/pro/ai-workflow-editor/src/app/layout.tsx");
